import styled from "styled-components"

const WidgetSection = styled.div<{ smallPadding?: boolean }>`
  padding: ${props => (props.smallPadding ? 8 : 18)}px 20px;
`

export default WidgetSection
